import React, { memo } from 'react';
import { UploadCloud } from 'lucide-react';

/**
 * Files section component
 * Displays attached files for a message
 */
const FilesSection = memo(({ files }) => {
  if (!files || files.length === 0) return null;
  
  return (
    <div className="mt-3 pt-3 border-t border-neutral-200 dark:border-neutral-800">
      <p className="text-xs font-medium flex items-center text-neutral-600 dark:text-neutral-600 mb-2">
        <UploadCloud size={12} className="mr-1 text-neutral-600 dark:text-neutral-600" />
        Files
      </p>
      <div className="flex flex-wrap gap-2">
        {files.map((file, idx) => (
          <div 
            key={idx} 
            className="text-xs bg-white/30 dark:bg-white/30 backdrop-blur-md px-3 py-2 rounded-md border border-white/60 dark:border-white/60 text-neutral-800 dark:text-neutral-800 font-semibold tracking-wide shadow-xl"
          >
            {file.name}
          </div>
        ))}
      </div>
    </div>
  );
});

FilesSection.displayName = 'FilesSection';

export default FilesSection;